<template>
  <LayoutPrincipal>
    <section class="tituloModulo">Configuración General</section>
    <section>
      <div class="configuraciones-flex">
        <section class="seccion-plazos">
          <h3>Configuración de</h3>

          <div class="btn-container-seccion">
            <button type="button" @click="guardarPlazos">Guardar cambios</button>
          </div>
        </section>
        <section class="seccion-permisos">
          <h3>Configuración de</h3>
          <div class="btn-container-seccion">
            <button type="button" @click="guardarPermisos">Guardar cambios</button>
          </div>
        </section>
        <section class="seccion-calendario">
          <h3>Configuración de</h3>
          <div class="btn-container-seccion">
            <button type="button" @click="guardarPermisos">Guardar cambios</button>
          </div>
        </section>
      </div>
    </section>
    <section style="display: flex; gap: 30px; margin-bottom: 20px;">
      <section class="seccion-extra">
        <div class="cotenedorCirBoton">
          <h3>Configuración de</h3>
          <div class="form-agregar-comunicadoDos">
            <input type="file" id="input-cumpleaneros" @change="subirCumpleImagen" accept="image/*" multiple
              class="input-file-hidden" />
            <label for="input-cumpleaneros" class="btn-subir-archivo">Subir imagen</label>
          </div>
        </div>
        <div v-if="cumpleaneros.length === 0" class="sin-comunicados">
          No hay información.
        </div>
        <ul v-else class="lista-comunicados">
          <li v-for="(item, index) in cumpleaneros" :key="'cumple-' + index">
            <div class="fecha">{{ formatearFecha(item.fecha) }}</div>
            <img :src="item.archivo" alt="Cumpleaños Escaneado" class="imagen-preview" />
            <button class="btn-borrar" @click="eliminarCumpleanero(index)" title="Eliminar imagen">×</button>
          </li>
        </ul>
      </section>
      <section class="seccion-extra">
        <div class="cotenedorCirBoton">
          <h3>Circulares</h3>
          <div class="form-agregar-comunicadoDos">
            <input type="file" id="input-circulares" @change="subirComunicadoArchivo" accept="application/pdf,image/*"
              multiple class="input-file-hidden" />
            <label for="input-circulares" class="btn-subir-archivo">Subir circular</label>
          </div>
        </div>
        <div v-if="comunicadosArchivo.length === 0" class="sin-comunicados">
          No hay información.
        </div>
        <ul v-else class="lista-comunicados">
          <li v-for="(item, index) in comunicadosArchivo" :key="'comunicado-arch-' + index">
            <div class="fecha">{{ formatearFecha(item.fecha) }}</div>
            <div v-if="esPDF(item.archivo)">
              <a :href="item.archivo" target="_blank">Ver archivo PDF</a>
            </div>
            <div v-else>
              <img :src="item.archivo" alt="Comunicado Escaneado" class="imagen-preview" />
            </div>
            <button class="btn-borrar" @click="eliminarComunicadoArchivo(index)" title="Eliminar comunicado">×</button>
          </li>
        </ul>
      </section>
      <section class="seccion-extra">
        <div class="cotenedorCirBoton">
          <h3>Comunicados</h3>
          <div class="form-agregar-comunicadoDos">
            <input type="file" accept="image/*" multiple class="input-file-hidden" />
            <label class="btn-subir-archivoNone"> Subir imagen</label>
          </div>
        </div>
        <div v-if="comunicadosTexto.length === 0" class="sin-comunicados">
          No hay comunicados textuales publicados.
        </div>
        <ul v-else class="lista-comunicados">
          <li v-for="(item, index) in comunicadosTexto" :key="'comunicado-texto-' + index">
            <div class="fecha">{{ formatearFecha(item.fecha) }}</div>
            <div class="texto">{{ item.texto }}</div>
            <button class="btn-borrar" @click="eliminarComunicadoTexto(index)" title="Eliminar comunicado">×</button>
          </li>
        </ul>
        <div class="form-agregar-comunicadoTres">
          <textarea v-model="nuevoComunicado.texto" class="textarea-comunicado"
            placeholder="Escribe aquí el comunicado..."></textarea>
          <Button class="btn-agregar-comunicado" @click="agregarComunicadoTexto">Agregar Comunicado</button>
        </div>
      </section>
    </section>
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import Button from "@/components/Forms/Button.vue";

export default {
  components: {
    LayoutPrincipal,
    Button,
  },
  data() {
    return {
      config: {
        juntaDirectiva: [
          {
            cargo: "Director",
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            firma: null,
          },
          {
            cargo: "Subdirector",
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            firma: null,
          },
          {
            cargo: "Secretario",
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            firma: null,
          },
          {
            cargo: "Tesorero",
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            firma: null,
          },
          {
            cargo: "Vocal 1",
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            firma: null,
          },
          {
            cargo: "Vocal 2",
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            firma: null,
          },
          {
            cargo: "Vocal 3",
            nombre: "",
            apellidoPaterno: "",
            apellidoMaterno: "",
            firma: null,
          },
        ],
        plazos: {
          anos: 5,
          porcentaje: 10.0,
        },
      },
      modulosDisponibles: [
        "Dashboard",
        "Administrador",
        "COBAES",
        "Pre-Altas",
        "Nómina",
        "Kiosco",
        "Devolución Fondo de Vivienda",
        "Préstamo de Vivienda",
        "Préstamos",
        "Configuración",
      ],
      empleadoSeleccionado: "",
      permisosPorPuesto: {
        Administrador: [],
        Contador: [],
        Secretario: [],
        Tesorero: [],
      },
      mostrarCalendario: false,
      cumpleaneros: [],
      comunicadosArchivo: [],
      comunicadosTexto: [],
      nuevoComunicado: {
        texto: "",
      },
      diasInhabiles: [],
      vacaciones: [],
      diasInhabilesInput: "",
      vacacionesInput: "",
    };
  },
  mounted() {
    this.permisosPorPuesto.Administrador = [...this.modulosDisponibles];
    this.cargarDatos();
  },
  methods: {
    guardarPlazos() {
      alert("Configuración de préstamos guardada");
    },
    guardarPermisos() {
      alert("Permisos guardados");
    },
    handleFirma(event, tipo, index) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this.config[tipo][index].firma = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    borrarFirma(index) {
      this.config.juntaDirectiva[index].firma = null;
    },
    actualizarPermisos() {
      if (this.empleadoSeleccionado === "Administrador") {
        this.permisosPorPuesto.Administrador = [...this.modulosDisponibles];
      }
    },
    abrirCalendario() {
      this.mostrarCalendario = true;
    },
    cerrarCalendario() {
      this.mostrarCalendario = false;
    },
    subirCumpleImagen(event) {
      const file = event.target.files[0]; // Solo toma uno
      if (!file || !file.type.startsWith("image/")) return;
      if (this.cumpleaneros.length >= 1) {
        alert(".");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.cumpleaneros = [{
          archivo: reader.result,
          fecha: new Date().toISOString(),
        }];
        this.guardarDatos();
      };
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    eliminarCumpleanero(index) {
      if (confirm("¿Seguro que quieres eliminar esta imagen?")) {
        this.cumpleaneros.splice(index, 1);
        this.guardarDatos();
      }
    },
    subirComunicadoArchivo(event) {
      const file = event.target.files[0];
      if (!(file && (file.type.startsWith("image/") || file.type === "application/pdf"))) return;
      if (this.comunicadosArchivo.length >= 1) {
        alert("Solo se permite una imagen.");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        this.comunicadosArchivo = [{
          archivo: reader.result,
          fecha: new Date().toISOString(),
        }];
        this.guardarDatos();
        this.agregarNotificacionGlobal("Se subió una nueva imagen.");
      };
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    eliminarComunicadoArchivo(index) {
      if (confirm("¿Seguro que quieres eliminar esta imagen?")) {
        this.comunicadosArchivo.splice(index, 1);
        this.guardarDatos();
      }
    },
    agregarComunicadoTexto() {
      if (this.comunicadosTexto.length >= 3) {
        alert("Solo se permiten 3 comunicados textuales.");
        return;
      }
      if (!this.nuevoComunicado.texto.trim()) {
        alert("El comunicado no puede estar vacío.");
        return;
      }
      this.comunicadosTexto.unshift({
        texto: this.nuevoComunicado.texto.trim(),
        fecha: new Date().toISOString(),
      });
      this.nuevoComunicado.texto = "";
      this.guardarDatos();
      this.agregarNotificacionGlobal("Nuevo comunicado publicado.");
    },
    eliminarComunicadoTexto(index) {
      if (confirm("¿Seguro que quieres eliminar este comunicado textual?")) {
        this.comunicadosTexto.splice(index, 1);
        this.guardarDatos();
      }
    },
    procesarDiasInhabiles() {
      this.diasInhabiles = this.diasInhabilesInput
        .split(",")
        .map(d => parseInt(d.trim()))
        .filter(d => !isNaN(d));
      this.guardarDatos();
    },
    procesarVacaciones() {
      this.vacaciones = this.vacacionesInput
        .split(",")
        .map(d => parseInt(d.trim()))
        .filter(d => !isNaN(d));
      this.guardarDatos();
    },
    guardarDatos() {
      localStorage.setItem("cumpleaneros", JSON.stringify(this.cumpleaneros));
      localStorage.setItem("comunicadosArchivo", JSON.stringify(this.comunicadosArchivo));
      localStorage.setItem("comunicadosTexto", JSON.stringify(this.comunicadosTexto));
      localStorage.setItem("diasInhabiles", JSON.stringify(this.diasInhabiles));
      localStorage.setItem("vacaciones", JSON.stringify(this.vacaciones));
    },
    cargarDatos() {
      const cumpleData = localStorage.getItem("cumpleaneros");
      const archivoData = localStorage.getItem("comunicadosArchivo");
      const textoData = localStorage.getItem("comunicadosTexto");
      const diasData = localStorage.getItem("diasInhabiles");
      const vacsData = localStorage.getItem("vacaciones");

      this.cumpleaneros = cumpleData ? JSON.parse(cumpleData) : [];
      this.comunicadosArchivo = archivoData ? JSON.parse(archivoData) : [];
      this.comunicadosTexto = textoData ? JSON.parse(textoData) : [];
      this.diasInhabiles = diasData ? JSON.parse(diasData) : [];
      this.vacaciones = vacsData ? JSON.parse(vacsData) : [];
      this.diasInhabilesInput = this.diasInhabiles.join(",");
      this.vacacionesInput = this.vacaciones.join(",");
    },
    formatearFecha(fecha) {
      return new Date(fecha).toLocaleDateString("es-MX", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    esPDF(dataUrl) {
      return dataUrl.startsWith("data:application/pdf");
    },
    agregarNotificacionGlobal(mensaje) {
      const notificaciones = JSON.parse(localStorage.getItem('notificaciones')) || [];
      notificaciones.push({
        titulo: 'Nuevo Comunicado',
        mensaje,
        fecha: new Date().toISOString()
      });
      localStorage.setItem('notificaciones', JSON.stringify(notificaciones));
      window.dispatchEvent(new Event('storage')); // para que otros componentes detecten cambios
    },
  },
};
</script>

<style scoped>
.tituloModulo {
  font-size: 25px;
  color: #6E44DA;
  font-weight: bolder;
  font-style: italic;
  margin-bottom: 20px;
  padding-left: 20px;
}

.tarjetas-horizontal-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
}

.tarjeta-miembro {
  flex: 1 1 220px;
  max-width: 220px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  box-sizing: border-box;
}

.tarjeta-miembro h3 {
  font-size: 18px;
  color: #444;
  margin-bottom: 16px;
  font-weight: 600;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
}

label {
  margin-bottom: 6px;
  font-weight: 600;
}

.input-file-hidden {
  display: none;
}

input[type="text"],
input[type="number"],
select,
textarea {
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  box-shadow: 0px 3px 6px #00000029;
  outline: none;
  color: #333;
  resize: none;
  font-family: inherit;
}

.btn-icon-plus {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 100%;
  background-color: #691c32e3;
  color: white;
  font-weight: bold;
  font-size: 24px;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
}

.firma-wrapper {
  position: relative;
  display: inline-block;
  margin-top: 10px;
}

.firma-preview {
  max-height: 80px;
  max-width: 180px;
  border: 1px solid #ccc;
  border-radius: 4px;
  object-fit: contain;
  display: block;
}

.btn-borrar {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4444;
  border: none;
  color: white;
  font-weight: bold;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  line-height: 18px;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  user-select: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-borrar:hover {
  background: #cc0000;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px 20px 20px;
}

button[type="button"] {
  padding: 10px 20px;
  background-color: black;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  font-weight: 600;
}

button[type="button"]:hover {
  background-color: #6E44DA;
}

.seccion-plazos,
.seccion-permisos,
.seccion-calendario {
  margin-top: 30px;
  background: #fff;
  padding: 15px 20px;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
}

.seccion-plazos h3,
.seccion-permisos h3,
.seccion-calendario h3 {
  color: black;
  margin-bottom: 15px;
}

.modulos-lista {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: space-between;
}

/* Modulos siempre en verde */
.checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f3f3f3;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 14px;
  color: #691c32e3;
  /* verde */
}

.configuraciones-flex {
  display: flex;
  gap: 30px;
  /*   flex-wrap: wrap; */
  justify-content: space-between;
}

.seccion-plazos,
.seccion-permisos,
.seccion-calendario {
  flex: 1 1 45%;
  min-width: 280px;
}

/* Botones de guardar en cada sección */
.btn-container-seccion {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}

.seccion-extra {
  margin: 30px 0px 0px;
  padding: 15px 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 3px 6px #00000029;
  width: 100%;
}

.seccion-extra h3 {
  color: black;
  margin-bottom: 0px;
  margin-top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}

/* Estilos para comunicados */
.form-agregar-comunicado {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
}

.form-agregar-comunicadoDos {
  margin-bottom: 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.form-agregar-comunicadoTres {
  margin-top: 16px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 100%;
}


.sin-comunicados {
  font-style: italic;
  color: #666;
  margin-top: 20px;
}

.lista-comunicados {
  list-style: none;
  padding: 0;
  max-width: 100%;
}

.lista-comunicados li {
  background: #f3f3f3;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 10px;
  position: relative;
  color: #691c32e3;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
}

.lista-comunicados .fecha {
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 6px;
}

.lista-comunicados .texto {
  font-size: 14px;
  white-space: pre-wrap;
}

.lista-comunicados .btn-borrar {
  position: absolute;
  top: 8px;
  right: 8px;
  font-weight: bold;
  /*   font-size: 16px; */
  background: #fff;
  border: none;
  color: #cc0000;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  user-select: none;
}

.lista-comunicados .btn-borrar:hover {
  color: #ff4444;
}

.imagen-preview {
  max-width: 100%;
  max-height: 300px;
  margin-top: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  object-fit: contain;
}

.btn-subir-archivo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  background-color: black;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;
  gap: 8px;
  width: fit-content;
}

.btn-subir-archivo:hover {
  background-color: #6E44DA;
}

.btn-subir-archivoNone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  background-color: white;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  transition: background 0.2s;
  user-select: none;
  gap: 8px;
  width: fit-content;
}

.input-file-hidden {
  display: none;
}

.cotenedorCirBoton {
  display: flex;
  justify-content: space-between;
}

.textarea-comunicado {
  height: 70px;
  padding: 12px 16px;
  font-size: 15px;
  border-radius: 10px;
  border: none;
  box-shadow: 0px 3px 6px #00000029;
  resize: none;
  color: #333;
  line-height: 1.5;
  background: white;
}
</style>
